(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cca-master-purchase-reassurance"] && !Shopify.designMode) return;
  try {
    if (!window.ccaPurchaseInboxTriggerReady) {
    window.ccaPurchaseInboxTriggerReady = true;

    const findPurchaseInbox = () => {
      const inbox = document.getElementById('ShopifyChat') || document.querySelector('shopify-chat');
      const directLauncher = inbox?.shadowRoot?.querySelector('button');
      const runtime = inbox?.shadowRoot?.querySelector('shopify-agent-runtime');
      const runtimeRoot = runtime?.shadowRoot;
      const launcher = directLauncher || runtimeRoot?.querySelector('button[part="activator"]');
      const panel = runtimeRoot?.querySelector('[role="dialog"]');
      const isOpen = inbox
        && (
          inbox.getAttribute('is-open') === 'true'
          || inbox.hasAttribute('open')
          || launcher?.getAttribute('aria-expanded') === 'true'
          || (panel && !panel.hasAttribute('inert'))
        );

      return { launcher, isOpen };
    };

    document.addEventListener('click', (event) => {
      const button = event.target.closest?.('[data-purchase-inbox-trigger]');
      if (!button || button.dataset.inboxOpening === 'true') return;

      button.dataset.inboxOpening = 'true';
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');

      const statusId = button.getAttribute('aria-describedby');
      const status = statusId ? document.getElementById(statusId) : null;
      if (status) status.textContent = button.dataset.loading;

      let lastLaunch = 0;
      let openSince = 0;
      let observer;
      let retry;
      let timeout;

      const finish = (opened) => {
        observer?.disconnect();
        if (retry) window.clearInterval(retry);
        if (timeout) window.clearTimeout(timeout);

        delete button.dataset.inboxOpening;
        button.disabled = false;
        button.removeAttribute('aria-busy');
        if (status) status.textContent = opened ? button.dataset.opened : button.dataset.unavailable;
      };

      const attempt = () => {
        const { launcher, isOpen } = findPurchaseInbox();
        if (isOpen) {
          if (!openSince) openSince = Date.now();
          if (Date.now() - openSince >= 350) finish(true);
          return;
        }

        openSince = 0;
        if (launcher && Date.now() - lastLaunch >= 750) {
          lastLaunch = Date.now();
          launcher.click();
        }
      };

      attempt();
      observer = new MutationObserver(attempt);
      observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true });
      retry = window.setInterval(attempt, 100);
      timeout = window.setTimeout(() => finish(false), 8000);
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cca-refund-policy-page"] && !Shopify.designMode) return;
  try {
    const refundPage = document.querySelector('.cca-refund');
  const refundSummaries = refundPage?.querySelectorAll('.cca-refund__disclosure summary') || [];

  refundSummaries.forEach((summary) => {
    summary.addEventListener('pointerdown', () => {
      summary.dataset.pointerFocus = 'true';
    });

    summary.addEventListener('keydown', () => {
      delete summary.dataset.pointerFocus;
    });

    summary.addEventListener('blur', () => {
      delete summary.dataset.pointerFocus;
    });
  });

  if (!customElements.get('cca-refund-chat')) {
    customElements.define('cca-refund-chat', class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.status = this.querySelector('[role="status"]');
        this.handleClick = this.openInbox.bind(this);
        this.button?.addEventListener('click', this.handleClick);
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.handleClick);
        this.finish(false, false);
      }

      findInbox() {
        const inbox = document.getElementById('ShopifyChat') || document.querySelector('shopify-chat');
        const directLauncher = inbox?.shadowRoot?.querySelector('button');
        const runtime = inbox?.shadowRoot?.querySelector('shopify-agent-runtime');
        const runtimeRoot = runtime?.shadowRoot;
        const launcher = directLauncher || runtimeRoot?.querySelector('button[part="activator"]');
        const panel = runtimeRoot?.querySelector('[role="dialog"]');
        const isOpen = inbox
          && (
            inbox.getAttribute('is-open') === 'true'
            || inbox.hasAttribute('open')
            || launcher?.getAttribute('aria-expanded') === 'true'
            || (panel && !panel.hasAttribute('inert'))
          );

        return { launcher, isOpen };
      }

      openInbox() {
        if (this.opening || !this.button) return;
        this.opening = true;
        this.lastLaunch = 0;
        this.openSince = 0;
        this.button.disabled = true;
        this.button.setAttribute('aria-busy', 'true');
        if (this.status) this.status.textContent = this.dataset.loading;

        const attempt = () => {
          const { launcher, isOpen } = this.findInbox();
          if (isOpen) {
            if (!this.openSince) this.openSince = Date.now();
            if (Date.now() - this.openSince >= 350) this.finish(true);
            return;
          }

          this.openSince = 0;
          if (launcher && Date.now() - this.lastLaunch >= 750) {
            this.lastLaunch = Date.now();
            launcher.click();
          }
        };

        attempt();
        this.observer = new MutationObserver(attempt);
        this.observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true });
        this.retry = window.setInterval(attempt, 100);
        this.timeout = window.setTimeout(() => this.finish(false), 8000);
      }

      finish(opened, updateStatus = true) {
        this.observer?.disconnect();
        window.clearInterval(this.retry);
        window.clearTimeout(this.timeout);
        this.observer = undefined;
        this.retry = undefined;
        this.timeout = undefined;
        this.opening = false;
        this.button?.removeAttribute('aria-busy');
        if (this.button) this.button.disabled = false;
        if (updateStatus && this.status) {
          this.status.textContent = opened ? this.dataset.opened : this.dataset.unavailable;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
